export const SIGNALS = {
  SELECT_LABEL: 'SELECT_LABEL',
  DESELECT_STORIES: 'DESELECT_STORIES',
  TOGGLE_LABEL_MANAGEMENT_MODAL: 'TOGGLE_LABEL_MANAGEMENT_MODAL',
  TOGGLE_STORY_FORM: 'TOGGLE_STORY_FORM',
  TOGGLE_GET_PAST_ITERATIONS: 'TOGGLE_GET_PAST_ITERATIONS',
  SEARCH: 'SEARCH',
  RESET_SEARCH: 'RESET_SEARCH',
  TOGGLE_NETWORK_ERROR_MESSAGE: 'TOGGLE_NETWORK_ERROR_MESSAGE',
  DISPLAY_SYSTEM_MESSAGE_MODAL: 'DISPLAY_SYSTEM_MESSAGE_MODAL',
  DISPLAY_STORY_MOVE_ERROR: 'DISPLAY_STORY_MOVE_ERROR',
} as Record<Signal, Signal>
